module.exports = __webpack_public_path__ + "assets/fonts/iconfont.de2aa756.eot";